import { Product } from 'modules/collections';

export const getItemsNumberText = (products: Product[]) => {
  const number = products.reduce((acc, { quantity }) => quantity + acc, 0);

  return number > 4 ? `${number} предметов` : `${number} предмета`;
};
